import { DateTime } from "luxon";
import { userPath } from "~/utils";

/**
 * Checks if the user qualifies for a Revolving program based on credit amount and path.
 */
export const isRevolving = (): boolean => {
  return getStateValue('isRevolving');
};

/**
 * Checks if the user qualifies for a Feevo program based on credit amount and path.
 */
export const isFeevo = () => {
  const PATH = userPath();
  return PATH == USER_PATHS.FE && !isRevolving();
};
